export const SET_QUIZ_WRONG_RESULTS = 'viewer/cats/SET_QUIZ_WRONG_RESULTS';
export const RESET_QUIZ_WRONG_RESULTS = 'viewer/cats/RESET_QUIZ_WRONG_RESULTS';
export const SET_PROFICIENCY_HISTORY = 'viewer/cats/SET_PROFICIENCY_HISTORY';
export const SET_DOMAINS_ELEMENTS = 'viewer/cats/SET_DOMAINS_ELMENTS';
export const SET_QUIZ_RESULT_CACHES = 'viewer/cats/SET_QUIZ_RESULT_CACHES';
export const SET_CAT_LIST = 'viewer/cats/SET_CAT_LIST';
export const SET_USER_RANKING = 'viewer/cats/SET_USER_RANKING';
export const SET_RANKING_SCORES = 'viewer/cats/SET_RANKING_SCORES';
export const SET_CAT_EXP_HISTORIES = 'viewer/cats/SET_CAT_EXP_HISTORIES';
export const SET_FLIGHT_BOX_REWARD_HISTORIES = 'viewer/cats/SET_FLIGHT_BOX_REWARD_HISTORIES';
